import { ProblemAndAnswer } from '@gmm/sdk-voodoo/shared';
import create from 'zustand';
import { devtools } from 'zustand/middleware';

export interface LockedProblem {
  positionWithinSkill: number;
  problemAndAnswer: ProblemAndAnswer;
}

interface SkillDiscoveryLockedSkillState {
  // exam id -> skillId -> LockedProblem[]
  map: Map<string, Map<string, LockedProblem[]>>;

  getLockedProblem: (
    examId: string,
    skillId: string,
    positionWithinSkill: number,
  ) => LockedProblem | undefined;

  addLockedProblem: (
    examId: string,
    skillId: string,
    lockedProblem: LockedProblem,
  ) => void;

  clearSkillDiscoveryLockedProblems: () => void;
}

export const useSkillDiscoveryLockedSkillsStore =
  create<SkillDiscoveryLockedSkillState>()(
    devtools(
      (set, get) => ({
        map: new Map(),

        getLockedProblem: (
          examId: string,
          skillId: string,
          positionWithinSkill: number,
        ) => {
          return get()
            .map.get(examId)
            ?.get(skillId)
            ?.find(lp => lp.positionWithinSkill === positionWithinSkill);
        },

        addLockedProblem: (
          examId: string,
          skillId: string,
          lockedProblem: LockedProblem,
        ) => {
          const oldMap = get().map;
          const map = new Map(oldMap);
          const examMap = new Map(map.get(examId));
          const oldLockedProblems = examMap.get(skillId) || [];
          const lockedProblems = [...oldLockedProblems, lockedProblem];
          examMap.set(skillId, lockedProblems);
          map.set(examId, examMap);
          set({ map });
        },

        clearSkillDiscoveryLockedProblems: () => {
          if (get().map.size === 0) return;
          set({ map: new Map() });
        },
      }),
      { name: 'SkillDiscoveryLockedSkillStore' },
    ),
  );
